export const getTaskAndTaskWorkflow = () => {
    return {
        task: '602414d84f9a1980cf5eafcc',
        taskWorkflow: '5e30afde097146a8fc3d5ceb'
    };
};
//# sourceMappingURL=get-task-and-task-workflow.js.map